const button = {
  background: 'red',
  color: 'white',
  fontSize: '1.8rem',
  fontWeight: '400',
  textAlign: 'center',
  padding: '.7rem 2.5rem',
  borderRadius: '1rem'
}

export default {
  confirmButton: {
    ...button,
    marginRight: '2rem'
  },
  rejectButton: {
    ...button,
    background: '#999999'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteCamera/style.js